/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import qs from "query-string";
import ReactLoading from "react-loading";

export const MarketplaceDetailAside = (props) => {
  const { icon, category, protocol = [], identity } = props;
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const [iconLoading, setIconloading] = useState(false);
  const [iconSrc, setIconSrc] = useState();
  const protocols = ["oidc", "saml", "cas", "asa"];
  const { consoleHost } =
    typeof window !== "undefined" && window._AUTHING__GLOBAL_CONFIG_;
  const TYPEMAP = {
    "co-office": {
      "zh-CN": "协同办公",
      "en-US": "Team Collaboration",
    },
    "cloud-computing": {
      "zh-CN": "云计算资源",
      "en-US": "Team Collaboration",
    },
    marketing: {
      "zh-CN": "营销管理",
      "en-US": "Marketing Management",
    },
    devtools: {
      "zh-CN": "开发工具",
      "en-US": "Developer Tool",
    },
    hr: {
      "zh-CN": "人力资源",
      "en-US": "Developer Tool",
    },
    finance: {
      "zh-CN": "财税费控",
      "en-US": "Finance And Tax",
    },
    security: {
      "zh-CN": "零信任和安全",
      "en-US": "Security",
    },
    erp: {
      "zh-CN": "ERP",
      "en-US": "ERP",
    },
    other: {
      "zh-CN": "其他",
      "en-US": "Other",
    },
  };
  const toUperMap = {
    oidc: "OIDC",
    saml: "SAML",
    cas: "CAS",
    asa: "ASA",
  };
  useEffect(() => {
    const imgDom = new Image();
    setIconloading(true);
    imgDom.src = icon;
    imgDom.onload = function () {
      setIconloading(false);
      setIconSrc(imgDom.src);
    };
  }, [icon]);
  return (
    <div className="marketplace-detail-aside">
      <div className="go-back">
        <a href="/apn">
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{ transform: "rotate(-90deg)", display: "inline-block" }}
          ></i>
          <span className="text">{t("marketplace.detailApp.btn-goback")}</span>
        </a>
      </div>
      <div className="app-icon">
        {iconLoading ? (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "40px",
            }}
          >
            <ReactLoading
              type="spinningBubbles"
              color="#215ae5"
              height={30}
              width={30}
            />
          </div>
        ) : (
          <img src={iconSrc} alt="authing" />
        )}
      </div>
      {id === "esign" && (
        <div className="get-app-button-false">
          {t("marketplace.detailApp.forward")}
        </div>
      )}
      {id !== "esign" && (
        <div
          className="get-app-button"
          onClick={() => {
            window.open(
              `${consoleHost}/login?${qs.stringify({
                state: `identifier.${id}`,
              })}`
            );
          }}
        >
          {t("marketplace.detailApp.btn-getapp")}
        </div>
      )}
      <div className="app-item">
        <div className="app-label">
          {t("marketplace.detailApp.label-category")}
        </div>
        {category?.map((item) => (
          <div className="app-tag">{TYPEMAP[item][i18n.language]}</div>
        ))}
      </div>
      <div className="app-item">
        <div className="app-label">
          {t("marketplace.detailApp.label-developer")}
        </div>
        <div className="app-text">
          {t("marketplace.detailApp.label-developer-company")}
        </div>
      </div>
      <div className="app-item">
        <div className="app-label">
          {t("marketplace.detailApp.label-ability")}
        </div>
        <div className="app-item-title">
          {t("marketplace.detailApp.label-protocol")}
        </div>
        {protocols?.map((normalProtocol) => {
          let result = "";
          protocol?.map((checkedProtocol) => {
            if (checkedProtocol === normalProtocol) {
              result = (
                <div className="app-item-label-checked">
                  <i className="icon authing-icon authing-check-line icon-style"></i>
                  {toUperMap[checkedProtocol]}
                </div>
              );
            }
            return null;
          });
          return result ? (
            result
          ) : (
            <div className="app-item-label-default">
              {toUperMap[normalProtocol]}
            </div>
          );
        })}
        {/* {protocols.map((normalProtocol) => {
          if (protocol === normalProtocol) {
            return (
              <div className="app-item-label-checked">
                <i className="icon authing-icon authing-check-line icon-style"></i>
                {toUperMap[protocol]}
              </div>
            );
          } else {
            return (
              <div className="app-item-label-default">
                {toUperMap[normalProtocol]}
              </div>
            );
          }
        })} */}
      </div>
    </div>
  );
};
